// React
import { ReactElement } from 'react';
// Next

//import { useTranslation } from 'next-i18next';
// Types
import { Slice } from '@utmb/types/slice-handler';
import { SliceStartElitesView } from '@utmb/types/index';
// Styles
import styles from './start-elites.module.scss';
import { StartElitesTable } from './StartElitesTable';

// Main Component
// noinspection JSUnusedGlobalSymbols
export const StartElites = (props: Slice<SliceStartElitesView>): ReactElement => {
    const { id, elitesView } = props;

    let previousRace = 0;

    return (
        <section id={id} className={`${styles.elitesContainer} container`}>
            {elitesView
                .filter((elites) => elites.race)
                .map((elites, index) => (
                    <div key={index}>
                        {previousRace !== elites.race?.id && (
                            <h3 id={`elite${(previousRace = elites.race?.id)}`}>
                                {elites.race?.name} {elites.race?.year}
                            </h3>
                        )}
                        <StartElitesTable {...elites} />
                    </div>
                ))}
        </section>
    );
};
